import React, { useEffect } from 'react'
import pageLog from "../../utils/pageLog";

const Pagelog = () => {


  useEffect(() => {
    const store = localStorage.getItem('app-store')
    let token, userInfo, userToken
    if (store) {
      const storeObj = JSON.parse(store)
      // console.log({ storeObj })
      token = storeObj?.state?.business?.token;
      userInfo = storeObj?.state?.user?.userInfo;
      userToken = storeObj?.state?.auth?.userToken;
      if (storeObj.state?.auth?.userToken) {

      }
    }

    const id = pageLog.generateGuid();
    let url;

    // Remove previous event listeners before adding new ones
    function removeListeners() {
      document.body.removeEventListener('click', handleClick);
      document.body.removeEventListener('mouseover', handleMouseover);
      document.body.removeEventListener('touchstart', handleTouchstart);
    }

    function handleEvent() {
      requestAnimationFrame(function () {
          if (window?.location?.href !== url && token) {
              url = window?.location?.href;
              const params = pageLog.getAgentInfo(id, userInfo?.UserId, window?.location?.pathname);
              pageLog.sendRequest({ params, token, jwt: userToken, apiUrl: "https://coreapi.bimeh.com" });
          }
      });
  }

    // Event handlers
    function handleClick() {
      handleEvent();
    }

    function handleMouseover() {
      handleEvent();
    }

    function handleTouchstart() {
      handleEvent();
    }

    // Remove previous listeners before adding new ones
    removeListeners();

    if (typeof window !== "undefined") {
      document.body.addEventListener('click', handleClick);
      document.body.addEventListener('mouseover', handleMouseover);
      document.body.addEventListener('touchstart', handleTouchstart);
  }

  // Clean-up function to remove listeners before unmounting or applying a new effect
  return removeListeners;
  }, [])
  return (
    null
  )
}

export default Pagelog
